import React from "react";
import "../deliveryNote/deliveryNote.scss";
import "react-datepicker/dist/react-datepicker.css";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import AddNewDeliveryProject from "../../components/deliveryNote/AddNewDeliveryProject";

const AddNewDeliveryNote = () => {
  return (
    <div className="container-fluid add-new-delivery-note-sec">
      <section className="delivery-note-add-sec mt-3">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <AddNewDeliveryProject />
          </div>
        </div>
      </section>
      {/* <!-- saveSuccessModal start--> */}

      <SaveSuccessModel SuccessName="Delivery note created successfully" />
    </div>
  );
};

export default AddNewDeliveryNote;
